import { translate } from 'loankeeper-common/helpers'
import { formName } from './constants'

export default (name: string): string => translate(formName, name)
export const translateWebMessages = (name: string): string => translate(`frm_web_messages-${name}`)
export const translateTransactions = (name: string): string => translate(`frm_loan_transactions-${name}`)
export const translateLKMessage = (name: string): string => translate(`LKMESSAGE-${name}`)
export const translateWriteOff = (name: string): string => translate(`frm_loan_writeoff_detail-${name}`)
export const translateHistory = (name: string): string => translate(`frm_auth_loanevent_history-${name}`)
export const translateOfficerAdd = (name: string): string => translate(`frm_loan_manager_add-${name}`)
export const translateActiveNotes = (key: string): string => translate('frm_RMD_All', key)
export const translateCollAddEdit = (name: string): string => translate(`frm_collateral_add_edit-${name}`)
